import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=afef3b30&scoped=true&"
import script from "./tooltip.ts?vue&type=script&lang=ts&"
export * from "./tooltip.ts?vue&type=script&lang=ts&"
import style0 from "./tooltip.scss?vue&type=style&index=0&id=afef3b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef3b30",
  null
  
)

export default component.exports